import { Component, Input, OnInit } from '@angular/core';
import { AddressInterface } from '../../../../account/models/address.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { AddressInterfaceState } from '../../../../account/store/state/address.state';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { OrderSimCardInterface } from '../../../models/order-sim-card.interface';
import { UpdateMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { GetAddress } from '../../../../account/store/actions/address.actions';
import { PriceDetailsInterface } from '../../../models/price-details.interface';

@Component({
  selector: 'app-not-received-sim-card',
  templateUrl: './not-received-sim-card.component.html',
  styleUrls: ['./not-received-sim-card.component.css'],
  standalone: false
})
export class NotReceivedSimCardComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  shippingAddress: AddressInterface|null;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.shippingAddress = null;
    this.formSubmitted = false;
    this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe( (result: AddressInterfaceState) => {
      if (null != result.address) {
        for (const addr of result.address) {
          if (addr.isPrincipal) {
            this.shippingAddress = addr;
          }
        }
      }
    });
    this.store.dispatch(new GetAddress());
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      const orderSimCardInterface = {
        step: 1,
        phoneNumber: this.line.phoneNumber,
        shippingAddressId: this.shippingAddress ? this.shippingAddress.id : null
      } as OrderSimCardInterface;
      this.store.dispatch(new UpdateMission(orderSimCardInterface, this.procedureCode));
    }
  }
}
